import React from "react";
import { makeStyles } from "@material-ui/styles";
import { RemoveCircle } from "@material-ui/icons";

const RemoveButton = (props) => {
  const classes = useStyles();

  return (
    <button
      className={classes.primaryButton}
      {...props}
    >
      <RemoveCircle style={{ fontSize: "1rem" }} />
    </button>
  );
};

export default RemoveButton;

const useStyles = makeStyles((theme) => ({
  primaryButton: {
    cursor: "pointer",
    color: "var(--red-400)",
    backgroundColor: "var(--white)",
    display: "flex",
    alignItems: "center",
    border: "none",
    justifyContent: "center",
    padding: "3px",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "var(--red-100)",
      transition: "all 0.2s ease-in-out",
    },
    "&:active": {
      backgroundColor: "var(--red-200)",
    },
  },
}));
